export interface ITicketContact {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  company: any;
}

export interface ITicketAssignUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  ProfileURL?: string;
}

export interface ITicketAssign {
  id: string;
  tenantId: string;
  ticketId: string;
  assignedType: string;
  assignedId: string;
  assignedUserId: string | null;
  assignedTeamId: string | null;
  createdAt: string;
  updatedAt: string;
  assignedUser: ITicketAssignUser | null;
  assignedTeam: any;
}

export interface ITicketCreatedBy {
  id: string;
  firstName: string;
  lastName: string;
}

export interface ITicket {
  id: string;
  tenantId: string;
  title: string;
  contactId: string;
  status: string;
  priority: string;
  ticketNo: number;
  description: string;
  createdAt: string;
  updatedAt: string;
  lastActivity: string;
  createdById: string;
  modifiedById: string | null;
  contact: ITicketContact;
  TicketAssign: ITicketAssign[];
  createdBy: ITicketCreatedBy;
  // Legacy or transformed fields
  customFields?: any[];
  customData?: Record<string, any>;
  source?: string;
  TicketFieldValue?: any[];
  attachment?: any;
  attachments?: any;
  // These are removed from the root in the new response, but kept optional if used by transform or UI
  assignedId?: string;
  assignedType?: string;
  assignedUser?: any;
  assignedTeam?: any;
}

export interface ITicketCreate {
  title: string;
  contactId: string;
  assignUsers: any[] | [];
  status: string;
  priority: string;
  description: string;
  [key: string]: unknown; // Allow string indexing for custom fields
}

export interface IGetTicketListResponse {
  data: {
    list: ITicket[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface ITicketListResult {
  list: ITicket[];
  total: number;
}

// COMMENT
export interface IComment {
  id: string;
  userName: string;
  ProfileURL: string;
  content: string;
  createdAt: string;
  attachments?: any;
}

export interface ICommentUser {
  id: string;
  tenantId: string;
  email: string;
  phoneNumber: string | null;
  firstName: string;
  lastName: string;
  status: string;
  ProfileURL: string | null;
  [key: string]: any;
}

export interface ICommentTicket {
  id: string;
  tenantId: string;
  title: string;
  ticketNo: number;
  status: string;
  priority: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  [key: string]: any;
}

export interface IGetCommentListResponse {
  data: {
    list: {
      id: string;
      tenantId: string;
      ticketId: string;
      userId: string;
      content: string;
      createdAt: string;
      updatedAt: string;
      ticket: ICommentTicket;
      user: ICommentUser;
      attachments: any[];
    }[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface ICommentListResult {
  list: IComment[];
  total: number;
}

export interface IAddCommentParams {
  ticketId: string;
  userId: string;
  content: string;
  fileUrl?: any;
  fileType?: any;
  filename?: any;
}

// OTHER

export interface IDefaultFilter {
  filters: [] | { fieldname: string; search?: string; sort?: number }[];
  globalSearch: string;
  page: number;
  limit: number;
}

export type QueryParams = {
  orderBy: string;
  page: number;
  rowsPerPage: number;
  globalSearch: string;
  fieldSearch: Record<string, string>;
  order: string;
  dateTimeFiltre?: any;
};

export const defaultFilter = {
  filters: [{ fieldname: 'createdAt', sort: 1 }],
  globalSearch: '',
  page: 1,
  limit: 10,
};
